import getAttributesImport from '../../store/attributes'
import { LOCALE_CHANGED } from '../../constants'
import { selectors as backendSelectors } from '../Backend'
import { selectors as steamSelectors } from '../Steam'

export const getAttributes = (locale) => {
    const attributes = getAttributesImport(locale)
    return {
        displaySeconds: attributes.ads.displaySeconds,
        steamOrigin: attributes.launcher.origin.steam,
        defaultOrigin: attributes.launcher.origin.default,
        url: attributes.service.adFeed,
        fallbackSource: attributes.ads.fallback.image_url,
        fallbackLink: attributes.ads.fallback.click_url,
    }
}

export const selectors = {
    getLocale: state => backendSelectors.getLocale(state),
    isSteamStartup: state => steamSelectors.isSteamStartup(state),
}

export const constants = {
    LOCALE_CHANGED,
}

export { launcherOpenUrl } from '../../launcherBackend/launcher-command'



// WEBPACK FOOTER //
// ./src/features/Creatives/imports.js